import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './MenuBarButton.module.css';
import { NavLink } from 'react-router-dom';
import { LFC } from '../../types';

interface MenuBarButtonProps {
  to: string;
  className?: string;
  icon?: ReactNode;
  inline?: boolean;
}

export const MenuBarButton: LFC<MenuBarButtonProps> = ({
  children,
  icon,
  to,
  inline,
  className,
}) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          styles.btn,
          isActive && styles.active,
          inline && styles.inline,
          className
        )
      }
    >
      {icon && <div className={styles.icn}>{icon}</div>}
      <div>{children}</div>
    </NavLink>
  );
};
